<template>
    <v-container class="busy-hour">
        <v-row :style="{marginLeft: '0px'}">
            <v-select class="select" v-model="selectedType" color="#c42111" :items="types" @change="onChange" />
            <span class="text" :class="{'disabled': selectedType != 'Busy Hour'}">Average top</span>
            <v-text-field class="input" color="#c42111" v-model="averageTop" outlined :disabled="selectedType != 'Busy Hour'" @change="onChange" :rules="[validation.posInt(averageTop)]" />
            <v-select class="select" v-model="selectedDevice" color="#c42111" :items="devices" @change="onChange" :disabled="!selectedType.toLowerCase().includes('busy hour')" />
            <span class="text" :class="{'disabled': !selectedType.toLowerCase().includes('busy hour')}">busy hour(s) using</span>
            <v-select class="select" v-model="selectedMethod" color="#c42111" :items="methods" @change="onChange" :disabled="!selectedType.toLowerCase().includes('busy hour')" />
        </v-row>

        <v-checkbox v-model="allowing" color="#c42111" class="" label="Allow more than one busy hour per day." @change="onChange" :disabled="selectedType != 'Busy Hour'"></v-checkbox>

    </v-container>
</template>

<script>
export default {
    name: 'BusyHour',
    props: ['param'],
    data: () => ({
        types: [],
        devices: [],
        methods: [],
        averageTop: 1,
        allowing: true,
        selectedType: "",
        selectedDevice: null,
        selectedMethod: null,
        validation: {
            posInt: (value) => (Number.isInteger(Number(value)) && value > 0) || `Value must be a positive integer`
        }
    }),

    computed: {
    },

    methods: {
        onChange: function(val) {
            if(val == "Daily Busy Hour") {
                this.averageTop = 1;
            }

            let selectedValue = '';
            selectedValue += `${this.types.indexOf(this.selectedType)} `;
            selectedValue += `${this.averageTop} `;
            selectedValue += `${this.devices.indexOf(this.selectedDevice)} `;
            selectedValue += `${this.methods.indexOf(this.selectedMethod)} `;
            selectedValue += `${this.allowing ? '0' : '1'}`;
            this.param.selectedValue = selectedValue;

            if(this.selectedType == "Busy Hour") {
                const latterText = ` ${this.allowing ? 'Allow' : 'Disallow'} more than one hour per day in average`;
                this.param.humanText = `Top ${this.averageTop} ${this.selectedDevice} busy hour${this.averageTop == 1 ? '' : 's'} using ` +
                    `${this.selectedMethod}${this.averageTop == 1 ? '' : latterText}`
            }
            else if(this.selectedType == "Daily Busy Hour") {
                this.param.humanText = `Daily ${this.selectedDevice} busy hour using ${this.selectedMethod}`;
            }
            else {
                this.param.humanText = `${this.selectedType}`;
            }

            this.$emit('edit');
        },

        buildLists: function() {
            let paramValues = this.param.rpt_param_values.slice(0);
            let paramValuesArray = [[],[],[],[], []];
            let inner = 0;
            for(let i = 0; i < paramValues.length; i++) {
                let paramValue = paramValues[i];
                if(paramValue !== "") {
                    paramValuesArray[inner].push(paramValue);
                }
                else {
                    inner += 1;
                }
            }
            this.types = paramValuesArray[0];
            this.averageTop = paramValuesArray[1][0];
            this.devices = paramValuesArray[2];
            this.methods = paramValuesArray[3];
            this.selectedType = this.types[0];
            this.selectedDevice = this.devices[0];
            this.selectedMethod = this.methods[0];
        },

        setInputsInitialValue: function() {
            if(this.$props.param.encodedValue == undefined) {
                return;
            }
            const parts = this.$props.param.encodedValue.split(' ');
            this.selectedType = this.types[parts[0]];
            this.averageTop = parseInt(parts[1]);
            this.selectedDevice = this.devices[parts[2]];
            this.selectedMethod = this.methods[parts[3]];
            this.allowing = (parts[4] == 0);
        }
    },

    mounted() {
        this.buildLists();
        this.setInputsInitialValue();
        this.onChange();
    }

  
};
</script>

<style scoped>

.busy-hour .select {
    display: inline-block;
    margin-right: 1em;
}

.busy-hour .text {
    margin-left: 1em;
    margin-right: 1em;
    margin-top: 1em;
    font-style: italic;
}
.busy-hour .text.disabled {
    color: #6F6F6F
}

.busy-hour .input {
    max-width: 50px;
}

</style>

